import { useMutation } from '@tanstack/react-query';

import {
  type UpsertRoomInput,
  gqlClient,
  graphql,
  queryClient,
} from '@tyro/api';
import { toast } from '@tyro/core';
import { useTranslation } from '@tyro/i18n';
import { roomKeys } from './keys';

const createRooms = graphql(/* GraphQL */ `
  mutation core_upsertRooms($input: [UpsertRoomInput]) {
    core_upsertRooms(input: $input) {
      roomId
    }
  }
`);

export function useCreateOrUpdateRoom() {
  const { t } = useTranslation(['common']);

  return useMutation({
    mutationKey: roomKeys.createOrUpdateRoom(),
    mutationFn: async (input: UpsertRoomInput[]) =>
      gqlClient.request(createRooms, { input }),
    onError: () => {
      toast.error(t('common:snackbarMessages.errorFailed'));
    },
    onSuccess: (_, variables) => {
      toast.success(
        variables?.[0]?.roomId
          ? t('common:snackbarMessages.updateSuccess')
          : t('common:snackbarMessages.createSuccess'),
      );
      queryClient.invalidateQueries({ queryKey: roomKeys.all });
    },
  });
}
